export default __webpack_public_path__ + "static/media/mentor.c7ff541c.svg";